const canonicalSpeedField = (direction) => `advertised_${direction}_mbps`;

export const getPackageSpeedRows = (
  packageInfo = {},
  { legacyRateUnit = "mbps" } = {}
) => {
  const cap = Number(packageInfo.cap);
  if (
    packageInfo.parked === true ||
    packageInfo.no_access === true ||
    (packageInfo.cap !== null && packageInfo.cap !== "" && cap === 0)
  ) {
    return [];
  }

  return ["download", "upload"].reduce((rows, direction) => {
    const canonicalField = canonicalSpeedField(direction);
    const hasCanonicalValue =
      Object.prototype.hasOwnProperty.call(packageInfo, canonicalField) &&
      packageInfo[canonicalField] !== undefined;
    const rawValue = hasCanonicalValue
      ? packageInfo[canonicalField]
      : packageInfo[`rate_${direction}`];
    const speed = Number(rawValue);
    const speedMbps =
      !hasCanonicalValue && legacyRateUnit === "kbps" ? speed / 1000 : speed;

    if (!Number.isFinite(speedMbps) || speedMbps <= 0) {
      return rows;
    }

    const label = direction === "download" ? "Download speed" : "Upload speed";
    rows.push({
      direction,
      label,
      value: `Up to ${speedMbps} Mbps`,
    });
    return rows;
  }, []);
};
